function cardpp() {
  $('.cardpp').each(function(){
    const $el = $(this)
    const $contin = $el.find('.cardpp--contin')

    /*
    **  RESIZE
    */
    const debounceResize = _.debounce(calc, 300)
    function calc() {
      let h = Math.ceil($contin.outerHeight())
      $el.css('--contHeight', `${h}px`)
    }


    /*
    **  EVENTS
    */
    function eventOn() {
      bus.on('pageLeaveEnd', eventOff)
      bus.on('resize', debounceResize)
      bus.on('resizeContainer', debounceResize)
    }

    function eventOff() {
      bus.off('pageLeaveEnd', eventOff)
      bus.off('resize', debounceResize)
      bus.off('resizeContainer', debounceResize)
    }

    /*
    **  INIT
    */
    eventOn()
    calc()
  })
}

export default cardpp